import { render, staticRenderFns } from "./CustomTargetingDetailModal.vue?vue&type=template&id=b65ee2d4&"
import script from "./CustomTargetingDetailModal.vue?vue&type=script&lang=js&"
export * from "./CustomTargetingDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports